import { Endpoint } from '../endpoint';

export const DataSource = new Endpoint('data_source');
